export function initTickerBlock(): void {
  const tickerInner = document.querySelector<HTMLElement>('.ticker-block__logos-inner');
  const tickerContainer = document.querySelector<HTMLElement>('.ticker-block__logos');
  if (!tickerInner || !tickerContainer) return;

  // Ensure at least 9 logos by duplicating as needed
  const originalLogos = Array.from(tickerInner.children);
  let logoCount = originalLogos.length;

  while (logoCount < 9) {
    originalLogos.forEach(logo => {
      if (logoCount < 9) {
        tickerInner.appendChild(logo.cloneNode(true));
        logoCount++;
      }
    });
  }

  // Duplicate all logos once for seamless infinite scroll
  tickerInner.innerHTML += tickerInner.innerHTML;

  // Calculate the width of the ticker content (half, since duplicated)
  const tickerWidth = tickerInner.scrollWidth / 2;
  const speed = 20; // pixels per second (adjust as needed)
  const duration = tickerWidth / speed;

  tickerInner.style.setProperty('--carousel-duration', `${duration}s`);
}

// Auto-initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTickerBlock);
} else {
  initTickerBlock();
}
